import { createFileRoute, redirect } from '@tanstack/react-router';
import { Outlet } from '@/lib/router-components';
import { useAuthStore } from '../stores/auth.store';

export const Route = createFileRoute('/certificacao')({
  component: CertificacaoLayout,
  beforeLoad: () => {
    const user = useAuthStore.getState().user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
  },
});

function CertificacaoLayout() {
  return (
    <div className="w-full min-h-full relative z-[1]">
      <Outlet />
    </div>
  );
}
